import React from 'react';
import { Link as LinkScroll } from 'react-scroll';
import { isBrowser, isMobile } from 'react-device-detect';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import ButtonBase from '../../Buttons/ButtonBase';
import FormDialog from '../Form/FormDialog';
import "./cardCost.scss"

const CardCost = (props) => {
  let { authClient, cost, quotation, handleClick } = props
  const [openForm, setOpenForm] = React.useState(false);

  const handleOpenForm = () => {
    setOpenForm(true);
  }

  const closeForm = () => {
    setOpenForm(false);
  }

  const tabletSize = useMediaQuery('(max-width: 768px');


  return (
    <>
      <section className="containerMain">
        <p className="containerMain_title">Costo de servicio</p>
        <article className="cardMain">
          <div>
            <div className="contentTextFirstAdvice">
              {authClient && authClient.cost && authClient.cost.consultingCost && authClient.cost.consultingCost === "no" ? <p className="textFirstAdvice">Primera asesoría con costo</p> : <p className="textFirstAdvice">Primera asesoría sin costo</p>}
              {authClient && authClient.cost && authClient.cost.consultingCost &&  authClient.cost.consultingCost === "no" && <div className="contentRangePrice">
                <p> {authClient && authClient.cost && authClient.cost.consultingCost === "no" && authClient.cost.costRange} </p>
                <p className="textContactLaywer">Contacta Abogado muestra un costo orientativo aplicado por el abogado</p>
              </div>}
            </div>
            <div className="contentTextFirstAdvice">
              <p className="textFirstAdvice">Tarifas que maneja</p>
              <div className="contentTypesOfRates">
                {authClient && authClient.cost && authClient.cost.typesOfRates && authClient.cost.typesOfRates.map(rates => {
                  return (
                    <>
                      {rates.selected === true && <div className="contentDataRates"> <div className="bulletMint" /><p className="textRateName">{rates.name}</p></div>}
                    </>
                  )
                })}
              </div>
            </div>
            <div className="contentContactLaywer">
              <p className="textContatLaywer">*Para recibir una mejor orientación acerca de los costos de servicios contacta directamente al abogado.</p>
            </div>
          </div>
          {quotation && (
            <LinkScroll to="contactForm" smooth={true} onClick={isMobile ? handleOpenForm : tabletSize ? handleOpenForm : () => { setTimeout(handleClick, 1000) }} >
              <ButtonBase variant="primary" style={{ marginTop: 24 }}>
                Solicitar cotización
              </ButtonBase>
            </LinkScroll>
          )}
        </article>
      </section>

      {(isMobile || (isBrowser && tabletSize)) && <FormDialog user={authClient} contact={authClient && authClient.contacto} openForm={openForm} handleClose={closeForm} />}
    </>
  );
};

export default CardCost;
